import { Document, Packer, Table, TableRow, TableCell, Paragraph, TextRun, WidthType, BorderStyle } from 'docx';
import { saveAs } from 'file-saver';

const BORDER = { style: BorderStyle.SINGLE, size: 1, color: '999999' };
const cellBorders = { top: BORDER, bottom: BORDER, left: BORDER, right: BORDER };

const headerCell = (text) =>
  new TableCell({
    borders: cellBorders,
    shading: { fill: 'E8E8E8' },
    children: [new Paragraph({ children: [new TextRun({ text, bold: true, size: 22 })] })],
  });

const bodyCell = (text) =>
  new TableCell({
    borders: cellBorders,
    children: [new Paragraph({ children: [new TextRun({ text: text || '', size: 22 })] })],
  });

export const downloadResultsDoc = async (rows) => {
  const headerRow = new TableRow({
    tableHeader: true,
    children: [headerCell('Question'), headerCell('Answer'), headerCell('Reasoning')],
  });

  const dataRows = rows.map(
    (row) =>
      new TableRow({
        children: [
          bodyCell(row.displayQuestion || row.question),
          bodyCell(row.answer || ''),
          bodyCell(row.reasoning || ''),
        ],
      })
  );

  const table = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    columnWidths: [2000, 4000, 4000],
    rows: [headerRow, ...dataRows],
  });

  const doc = new Document({
    sections: [{ children: [table] }],
  });

  const blob = await Packer.toBlob(doc);
  saveAs(blob, 'query-series-results.docx');
};
